import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
  };

  const discount = product.originalPrice 
    ? Math.round((1 - product.price / product.originalPrice) * 100) 
    : 0;

  return (
    <Link 
      to={`/product/${product.id}`} 
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden">
        {/* Image Container */}
        <div className="relative aspect-square overflow-hidden bg-slate-50">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
          {discount > 0 && (
            <span className="absolute top-3 left-3 bg-orange-400 text-white text-xs font-bold px-2 py-1 rounded-full">
              -{discount}%
            </span>
          )}
          {product.isBestseller && (
            <span className="absolute top-3 right-3 bg-sky-500 text-white text-xs font-bold px-2 py-1 rounded-full">
              Bestseller
            </span>
          )}
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 
            className="text-slate-800 font-semibold mb-2 line-clamp-2 group-hover:text-sky-500 transition-colors"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            {product.name}
          </h3>

          {/* Rating */}
          <div className="flex items-center gap-1 mb-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={14}
                  className={i < Math.floor(product.rating) ? 'fill-yellow-400 text-yellow-400' : 'text-slate-300'}
                />
              ))}
            </div>
            <span className="text-sm text-slate-500">({product.reviews})</span>
          </div>

          {/* Price */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-lg font-bold text-slate-800" style={{ fontFamily: 'Quicksand, sans-serif' }}>
                ${product.price.toFixed(2)}
              </span>
              {product.originalPrice && (
                <span className="text-sm text-slate-400 line-through">
                  ${product.originalPrice.toFixed(2)}
                </span>
              )}
            </div>
            <Button
              size="sm"
              className="rounded-full bg-orange-400 hover:bg-orange-500 text-white shadow-[0px_3px_0px_0px_#cc8400] hover:shadow-[0px_2px_0px_0px_#cc8400] active:shadow-none transition-all"
              onClick={handleAddToCart}
              data-testid={`add-to-cart-${product.id}`}
            >
              <ShoppingCart size={16} />
            </Button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
